<mat-drawer-container [hasBackdrop]="false">
    <mat-drawer mode="over" [opened]="isOpened" position="end" [autoFocus]="false">
        <mat-drawer-content>
            <ng-template cdkPortalOutlet></ng-template>
        </mat-drawer-content>
    </mat-drawer>
</mat-drawer-container>
